/** Account (Conta) page copy */
export const accountPt = {
  kicker: 'Área do jogador',
  title: 'Sua conta',
  leadLogged:
    'Gerencie VIP, copie o IP, acompanhe o servidor e seus pagamentos — tudo no mesmo lugar.',
  leadGuest:
    'Conecte o Discord para liberar painel VIP, histórico e atalhos do Nexus.',
  greetingMorning: 'Bom dia',
  greetingAfternoon: 'Boa tarde',
  greetingEvening: 'Boa noite',
  playerFallback: 'Jogador',
  gateTitle: 'Entre com Discord',
  gateLead:
    'Uma conexão libera plano, faturas e atalhos. Sem senha nova — só o Discord que você já usa no servidor.',
  gateStep1: 'Conecta o Discord',
  gateStep2: 'Vê plano e pagamentos',
  gateStep3: 'Gerencia renovação no Stripe',
  connectDiscord: 'Conectar Discord',
  loggedAs: 'Logado como',
  refresh: 'Atualizar',
  refreshing: 'Atualizando…',
  logout: 'Sair',
  shortcuts: 'Atalhos',
  copyIp: 'Copiar IP',
  discordCommunity: 'Comunidade Nexus',
  vipPlans: 'Planos VIP',
  vipPlansHint: 'Origin, Eclipse e mais',
  home: 'Início',
  homeHint: 'Voltar ao site',
  activePlan: 'Plano ativo',
  loadingPlan: 'Carregando seu plano…',
  currentCycle: 'Ciclo atual',
  renewsToday: 'Renova hoje',
  oneDayLeft: '1 dia restante',
  daysLeft: '{{count}} dias restantes',
  validUntil: 'VIP válido até {{date}}',
  nextRenewalOn: 'Próxima renovação em {{date}}',
  mcNick: 'Nick Minecraft',
  billing: 'Cobrança',
  billingAnnual: 'Anual',
  billingMonthly: 'Mensal',
  payment: 'Pagamento',
  payPix: 'PIX',
  payCard: 'Cartão (Stripe)',
  validUntilLabel: 'Válido até',
  nextRenewalLabel: 'Próxima renovação',
  copyNick: 'Copiar nick',
  perksTitle: 'O que você tem com este plano',
  renewPix: 'Renovar via PIX',
  opening: 'Abrindo…',
  manageRenew: 'Gerenciar / renovar',
  reactivateStripe: 'Reativar no Stripe',
  subscribePlan: 'Assinar um plano',
  comparePlans: 'Comparar planos',
  emptyVip:
    'Você ainda não tem VIP neste Discord. Escolha um plano e destrave perks no servidor.',
  viewVip: 'Ver planos VIP',
  paymentsTitle: 'Histórico de pagamentos',
  loading: 'Carregando…',
  noPayments: 'Nenhum pagamento encontrado ainda.',
  noPaymentsStripe: ' Assim que houver cobranças na Stripe, elas aparecem aqui.',
  noPaymentsAfter: ' Após assinar, o histórico entra automaticamente.',
  invoice: 'Fatura',
  serverTitle: 'Servidor',
  serverLead: 'Status ao vivo e IP oficial para entrar no mundo.',
  copyServerIp: 'Copiar IP do servidor',
  nextSteps: 'Próximos passos',
  tipSubscribe: 'Assine um VIP',
  tipSubscribeRest: ' para cargos no Discord e perks no LuckPerms.',
  tipDiscordBefore: 'Entre no ',
  tipDiscordAfter: ' para anúncios e suporte.',
  tipNickBefore: 'Confira se o nick ',
  tipNickAfter: ' está certo no jogo.',
  errLoad: 'Não foi possível carregar sua conta.',
  errPortal: 'Não foi possível abrir o portal de pagamento.',
  toastCopied: '{{label}} copiado',
  toastCopyFail: 'Não foi possível copiar',
  payStatus: {
    paid: 'Pago',
    open: 'Aberto',
    draft: 'Rascunho',
    uncollectible: 'Não cobrado',
    void: 'Anulado',
  },
  highlights: {
    origin: [
      'Prefixo [Origin] e cores no chat',
      'Canal VIP + 2 homes',
      '10.000 blocos de proteção',
      'Salário 1.000/dia',
      'Prioridade na fila',
    ],
    eclipse: [
      '20.000 blocos de proteção',
      'Salário 2.500/dia',
      'Taxa PIX 5% e 4 cofres',
      'Kit mensal e /craft + /ec',
      'Acesso antecipado a eventos',
    ],
    investidor: [
      'Tudo do Eclipse incluso',
      'Salário 5.000/dia',
      'Taxa PIX 0% e 5 cofres',
      'Kit semanal + /craft, /ec e /anvil',
      'Suporte prioritário',
    ],
  },
};

export const accountEn = {
  kicker: 'Player area',
  title: 'Your account',
  leadLogged:
    'Manage VIP, copy the IP, check the server and your payments — all in one place.',
  leadGuest:
    'Connect Discord to unlock the VIP panel, history, and Nexus shortcuts.',
  greetingMorning: 'Good morning',
  greetingAfternoon: 'Good afternoon',
  greetingEvening: 'Good evening',
  playerFallback: 'Player',
  gateTitle: 'Sign in with Discord',
  gateLead:
    'One connection unlocks your plan, invoices, and shortcuts. No new password — just the Discord you already use on the server.',
  gateStep1: 'Connect Discord',
  gateStep2: 'See plan and payments',
  gateStep3: 'Manage renewal on Stripe',
  connectDiscord: 'Connect Discord',
  loggedAs: 'Signed in as',
  refresh: 'Refresh',
  refreshing: 'Refreshing…',
  logout: 'Sign out',
  shortcuts: 'Shortcuts',
  copyIp: 'Copy IP',
  discordCommunity: 'Nexus community',
  vipPlans: 'VIP Plans',
  vipPlansHint: 'Origin, Eclipse & more',
  home: 'Home',
  homeHint: 'Back to the site',
  activePlan: 'Active plan',
  loadingPlan: 'Loading your plan…',
  currentCycle: 'Current cycle',
  renewsToday: 'Renews today',
  oneDayLeft: '1 day left',
  daysLeft: '{{count}} days left',
  validUntil: 'VIP valid until {{date}}',
  nextRenewalOn: 'Next renewal on {{date}}',
  mcNick: 'Minecraft nick',
  billing: 'Billing',
  billingAnnual: 'Yearly',
  billingMonthly: 'Monthly',
  payment: 'Payment',
  payPix: 'PIX',
  payCard: 'Card (Stripe)',
  validUntilLabel: 'Valid until',
  nextRenewalLabel: 'Next renewal',
  copyNick: 'Copy nick',
  perksTitle: 'What you get with this plan',
  renewPix: 'Renew via PIX',
  opening: 'Opening…',
  manageRenew: 'Manage / renew',
  reactivateStripe: 'Reactivate on Stripe',
  subscribePlan: 'Subscribe to a plan',
  comparePlans: 'Compare plans',
  emptyVip:
    'You don\'t have VIP on this Discord yet. Pick a plan and unlock perks on the server.',
  viewVip: 'View VIP plans',
  paymentsTitle: 'Payment history',
  loading: 'Loading…',
  noPayments: 'No payments found yet.',
  noPaymentsStripe: ' Once there are Stripe charges, they show up here.',
  noPaymentsAfter: ' After you subscribe, history appears automatically.',
  invoice: 'Invoice',
  serverTitle: 'Server',
  serverLead: 'Live status and official IP to join the world.',
  copyServerIp: 'Copy server IP',
  nextSteps: 'Next steps',
  tipSubscribe: 'Subscribe to VIP',
  tipSubscribeRest: ' for Discord roles and LuckPerms perks.',
  tipDiscordBefore: 'Join ',
  tipDiscordAfter: ' for announcements and support.',
  tipNickBefore: 'Make sure the nick ',
  tipNickAfter: ' is correct in-game.',
  errLoad: 'Could not load your account.',
  errPortal: 'Could not open the payment portal.',
  toastCopied: '{{label}} copied',
  toastCopyFail: 'Could not copy',
  payStatus: {
    paid: 'Paid',
    open: 'Open',
    draft: 'Draft',
    uncollectible: 'Uncollectible',
    void: 'Void',
  },
  highlights: {
    origin: [
      '[Origin] prefix and chat colors',
      'VIP channel + 2 homes',
      '10,000 protection blocks',
      'Salary 1,000/day',
      'Queue priority',
    ],
    eclipse: [
      '20,000 protection blocks',
      'Salary 2,500/day',
      'PIX fee 5% and 4 vaults',
      'Monthly kit and /craft + /ec',
      'Early event access',
    ],
    investidor: [
      'Everything in Eclipse included',
      'Salary 5,000/day',
      'PIX fee 0% and 5 vaults',
      'Weekly kit + /craft, /ec and /anvil',
      'Priority support',
    ],
  },
};
